
import React, {  useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortUp, faSortDown } from "@fortawesome/free-solid-svg-icons";
import ExportCSVButton from '../utils/ExportCSVButton';

const Liberadas = ({
 allItems,
  filters,
  setFilters,
  requestSort,
  sortConfig,
  renderPagination,
  renderSelectFilters,
}) => {
  // Solo campos relevantes para este reporte
   const keyMap = {
    "Cliente": "clienteRazonSocial",
    "Fecha Arribo": "fechaArribo",
    "Carrier": "carrier",
    "Tracking": "numeroBolMaster",
    "Usuario": "usuario",
    "Proveedor": "proveedor",
    "Bultos": "bultos",
    "Peso": "peso",
    "No. Factura": "noFactura",
    "No. de Parte": "noParte",
    "Piezas por No. de Parte": "cantidadParte",
    "ClaveIN/A1/F": "clavePedimento",
    "Incoterm": "incotermFactura",
    "No. Pedimento": "pedimento",
    "Fecha de Pedimento": "fechaPago",
    "Remesa": "remesaPedimento",
    "Fecha de Entrega a Planta": "fechaModulacion",
    "Resultado": "estadoModulacion",
  };

  const columnWidths = {
      "clienteRazonSocial": "350px",
      "planta": "90px",
      "referencia": "150px",
      "pedimento": "150px",
      "numeroBolMaster": "150px",
      "fechaArribo": "120px",
      "proveedor": "550px",
      "bultos": "100px",
      "peso": "100px",
      "dias": "200px",
      "observaciones": "200px",
      "contactoWisdom": "150px",
      "almacenajes": "120px",
  };
  const gridTemplateColumnsStyle = {
    display: "grid",
    gridTemplateColumns: Object.values(keyMap)
      .map((key) => columnWidths[key] || "150px")
      .join(" "),
  };
  // Filtro aplicado a los datos globales
  const items = useMemo(() => {
    return allItems
      .filter(item => item.statusGuia === "Liberada") 
      .filter((item) =>
        Object.entries(filters).every(
          ([key, selectedOptions]) =>
            selectedOptions.length === 0 ||
            selectedOptions.some((option) => option.value === item[key])
        )
      );
  }, [allItems, filters]);

  const csvData = items.length > 0
    ? items.map(item => {
      const row = {};
      Object.entries(keyMap).forEach(([header, key]) => {
        row[header] = item[key] ?? "";
      });
      return row;
    })
    : [Object.keys(keyMap).reduce((acc, header) => {
      acc[header] = ""; // Agrega encabezados aunque sin datos
      return acc;
    }, {})];


  return (
    <>
      {renderSelectFilters()}
      <div className="flex justify-end">
        <ExportCSVButton data={csvData} filename="reporte_guias_liberadas.csv"/>
      </div>
      {renderPagination()}
      <div className="py-8">
        <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
          <div className="inline-block min-w-full shadow-lg rounded-lg overflow-hidden">
            <div
              className="bg-gray-200 px-6 py-3 grid items-center border-b border-gray-300 sticky top-0 z-10"
              style={{ ...gridTemplateColumnsStyle, minHeight: "48px" }}
            >
              {Object.keys(keyMap).map((header, index) => {
                const key = keyMap[header];
                let sortIcon =
                  sortConfig.key === key ? (
                    sortConfig.direction === "ascending" ? (
                      <FontAwesomeIcon
                        icon={faSortUp}
                        className="text-blue-600"
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={faSortDown}
                        className="text-blue-600"
                      />
                    )
                  ) : (
                    <FontAwesomeIcon
                      icon={faSortUp}
                      className="text-gray-400"
                    />
                  );
                return (
                  <div
                    key={index}
                    className={`text-xs font-semibold uppercase tracking-wider text-center py-2 cursor-pointer ${
                      sortConfig.key === key ? "text-blue-600" : "text-gray-700"
                    } hover:text-blue-400`}
                    onClick={() => requestSort(key)}
                  >
                    {header} {sortIcon}
                  </div>
                );
              })}
            </div>

            <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
              {items.map((item, index) => (
                <div
                  key={index}
                  className={`grid items-center text-center text-sm ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  } hover:bg-gray-100`}
                  style={{ ...gridTemplateColumnsStyle, minHeight: "48px" }}
                >
                  {Object.entries(keyMap).map(([header, key], colIndex) => {
                    const cellValue = item[key] || "";
                    return (
                      <div
                        key={colIndex}
                        className="text-xs px-2 py-3 border-b border-gray-200"
                      >
                        {cellValue}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {renderPagination()}
    </>
  );
};

export default Liberadas;
